export function updateUserImageURL(url) {
  return {
    type: '@user/UPDATE_USER_IMAGE_URL',
    payload: { url },
  };
}
